import script from "./TourGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./TourGuide.vue?vue&type=script&setup=true&lang=js"

import "./TourGuide.vue?vue&type=style&index=0&id=9073fe04&lang=css"

const __exports__ = script;

export default __exports__